import React from 'react'
import "../styles/blogs.css"

export default function Blog(props) {
  const {title,description,link,pubDate,thumbnail,category} = props;

  // const colors = 
  const colors = [
    { name: "Turquoise", color: "#1abc9c" },
    { name: "Emerald", color: "#2ecc71" },
    { name: "PeterRiver", color: "#3498db" },
    { name: "Amethyst", color: "#9b59b6" },
    { name: "WetAsphalt", color: "#34495e" },
    { name: "GreenSea", color: "#16a085" },
    { name: "Nephritis", color: "#27ae60" },
    { name: "BelizeHole", color: "#2980b9" },
    { name: "Wisteria", color: "#8e44ad" },
    { name: "MidnightBlue", color: "#2c3e50" },
    { name: "SunFlower", color: "#f1c40f" },
    { name: "Carrot", color: "#e67e22" },
    { name: "Alizarin", color: "#e74c3c" },
    { name: "Concrete", color: "#95a5a6" },
    { name: "Orange", color: "#f39c12" },
    { name: "Pumpkin", color: "#d35400" },
    { name: "Pomegranate", color: "#c0392b" },
    { name: "Asbestos", color: "#7f8c8d" },
    { name: "OrchidOrange", color: "#FEA47F" },
    { name: "SpiroDiscoBall", color: "#25CCF7" },
    { name: "HoneyGlow", color: "#EAB543" },
    { name: "SweetGarden", color: "#55E6C1" },
    { name: "FallingStar", color: "#CAD3C8" },
    { name: "RichGardenia", color: "#F97F51" },
    { name: "ClearChill", color: "#1B9CFC" },
    { name: "Keppel", color: "#58B19F" },
    { name: "ShipsOfficer", color: "#2C3A47" },
    { name: "FieryFuchsia", color: "#B33771" },
    { name: "BlueBell", color: "#3B3B98" },
    { name: "GeorgiaPeach", color: "#FD7272" },
    { name: "OasisStream", color: "#9AECDB" },
    { name: "BrightUbe", color: "#D6A2E8" },
    { name: "MagentaPurple", color: "#6D214F" },
    { name: "EndingNavyBlue", color: "#182C61" },
    { name: "SasquatchSocks", color: "#FC427B" },
    { name: "PineGlade", color: "#BDC581" },
    { name: "HighlighterLavender", color: "#82589F" }
  ]

  const randomColor =()=>{
    return colors[Math.floor(Math.random() * colors.length)].color;
  }
  const Label = category.map((cat)=>{
    return(
      <span className="blog__category" style={{backgroundColor: randomColor()}}>{cat}</span>
    )
  })
  return (
    <div className="box">
        <img src={thumbnail} alt={title}/>
        <div className="blog__content">
            <h3 className="blog__title">{title}</h3>
            <p className="blog__description">{description}
            <a  className="blog__link"href={link} target="_blank" rel="noreferrer">Read More ....</a>
            </p>
            <p className="blog__pubDate">{pubDate}</p>
            {/* <p className="blog__date">{date}</p> */}
            <p className="blog__label">{Label}</p>
          
         </div>
    </div>
  )
}
